import Image from '@feature/Image'
import TermWebsiteLink from '@feature/TermWebsiteLink'
import { Divider, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getSelectTermsById, selectGlobalCopy } from 'app/selectors'
import { showTerms } from 'app/thunks'
import React from 'react'
import { TaxonomyId, TermBase, TermId } from 'types'

export type StockistsProps = {
  termsBases?: TermBase[]
  termIds?: TermId[]
}

const Stockists = ({ termsBases, termIds, ...props }: StockistsProps) => {
  let theTermIds: number[] = [];

  if (termIds && termIds.length) theTermIds = termIds;
  if (termsBases && termsBases.length) theTermIds = termsBases.map((t) => t.id);

  const dispatch = useAppDispatch()
  const taxonomyId: TaxonomyId = 'STOCKIST'
  const globalCopy = useAppSelector(selectGlobalCopy)
  const stockists = useAppSelector(getSelectTermsById(taxonomyId, theTermIds))

  React.useEffect(() => {
    dispatch(showTerms(taxonomyId))
  }, [dispatch, taxonomyId])

  return !stockists.length ? (
    <></>
  ) : (
    <Stack {...props} spacing={3}>
      <Box>
        <Typography mb={1}>{globalCopy.stockistsHeading}</Typography>
        <Typography variant="small">{globalCopy.stockistsDesc}</Typography>
      </Box>

      <Box>
        <Typography variant="bold" mb={1}>
          Stockists
        </Typography>
        <Divider />
      </Box>
      {stockists.map((term, i) => {
        return (
          <Stack key={i} direction="row" alignItems="center" spacing={2}>
            <Stack width={70}>
              <Image imageData={term?.image} contain ratio={1} size="LARGE" withBorder borderRadius={'50%'} />
            </Stack>
            <Stack alignItems="flex-start">
              <Typography>{term?.name}</Typography>
              <TermWebsiteLink term={term} variant="text" sx={{ color: 'common.black', paddingX: 0 }} />
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default Stockists
